import React from 'react';
import { Box } from '@mui/material';

const LoadingDots = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
      }}
    >
      {[0, 1, 2].map((index) => (
        <Box
          key={index}
          sx={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            bgcolor: 'primary.main',
            animation: 'pulse 1.4s ease-in-out infinite',
            animationDelay: `${index * 0.16}s`,
            '@keyframes pulse': {
              '0%, 100%': {
                transform: 'scale(0.6)',
                opacity: 0.6,
              },
              '50%': {
                transform: 'scale(1)',
                opacity: 1,
              },
            },
          }}
        />
      ))}
    </Box>
  );
};

export default LoadingDots; 